import React from 'react';

import {BaseDialog, Role} from 'dialogs/BaseDialog';
import theme from './FailedArchiving.scss';
import errorImg from './i_error.png';
import conf from 'configuration.json';
import {getMessage as msg} from 'MessageBundle';
import {replaceLineEnds} from 'common/Replace';

export default class FailedArchiving extends BaseDialog {

    constructor(props) {
        super(props);

        const path = this.props.match.path; // current location path, e.g. /retryArchiving
        const pathname = this.props.location.pathname; // current location pathname, e.g. /retryArchiving/<complaintNumber>

        try {
            this.complaintNumber = atob(pathname.replace(path + "/", ""));
        } catch (e) {
            window.location.href = '/';
        }

        this.state = {};
    }

    getAllowedRoles() {
        return [Role.ADMIN];
    }

    componentDidMount() {
        super.init(this.reloadErrors);
    }

    reloadErrors = () => {
        this.request('get', conf.rest.complaintArchiveEndpoint + '/' + this.complaintNumber)
            .send((result) => {
                this.setState({
                    errorDescriptions: result.body,
                    initialized: true
                });
            });
    };

    handleArchivingRetry = () => {
        this.setState({
            initialized: false
        });
        this.request('post', conf.rest.complaintArchiveEndpoint + '/' + this.complaintNumber)
            .send(this.closeWindow, this.reloadErrors);
    };

    getDialog() {
        return (
            <div className={theme.failedArchiving}>
                <h2>{msg('failedArchiving.header')}</h2>
                <div>
                    <div className={theme.blcError}><img src={errorImg} alt=" " role="presentation"/><span>{msg('failedArchiving.errorBox')}</span></div>
                    <dl>
                        <dt>{msg('failedArchiving.label.complaintNumber')}</dt>
                        <dd>{this.complaintNumber}</dd>

                        <dt>{msg('failedArchiving.label.errorDescriptions')}</dt>
                        {this.state.errorDescriptions.map(errorDescription =>
                            <dd>{replaceLineEnds(errorDescription)}</dd>
                        )}
                    </dl>
                    <span className={theme.hint}>{msg('failedArchiving.hint')}</span>
                    <div className={theme.btnGroupMini}>
                        <button id="close-btn" onClick={this.closeWindow}>{msg('failedArchiving.button.close')}</button>
                        <button id="retry-btn" onClick={this.handleArchivingRetry} className={theme.accent}>
                            {msg('failedArchiving.button.retry')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/FailedArchiving/index.js